import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { ToolboxTalkTemplateModel } from 'src/app/models/toolbox-talk-template.model';
import { ApiService } from 'src/app/shared/api.service';
import { UtilsService } from '../../shared/utils.service';
import { ApiRequestService } from 'src/app/shared/api-request.service';
import {ToolboxTalksTemplatesEditComponent} from "../toolbox-talks-templates-edit/toolbox-talks-templates-edit.component";
import {ToolboxTalksTemplatesTabsComponent} from "../toolbox-talks-templates-tabs/toolbox-talks-templates-tabs.component";
import {UserPublicProfileComponent} from "../../shared/user-public-profile/user-public-profile.component";

@Component({
  selector: 'app-toolbox-talks-templates-view',
  templateUrl: './toolbox-talks-templates-view.component.html',
  styleUrls: ['./toolbox-talks-templates-view.component.scss']
})
export class ToolboxTalksTemplatesViewComponent implements OnInit {

  @Input() ToolboxTalksTemplatesTabsComponent: ToolboxTalksTemplatesTabsComponent;

  toolbox_talk: ToolboxTalkTemplateModel = new ToolboxTalkTemplateModel();
  reported_by_user: any;

  constructor(
    public app: AppService,
    private oldApi: ApiService,
    private api: ApiRequestService,
    public router: Router,
    public renderer: Renderer2,
    public route: ActivatedRoute,
    public utils: UtilsService
  ) {}

  ngOnInit() {
    if (!this.toolbox_talk.id) {
      this.toolbox_talk.id = Number(
        this.route.snapshot.params['toolbox_talk_id']
      );
    }

    if (this.toolbox_talk.id) {
      this.getToolboxTalk(Number(this.toolbox_talk.id));
    }
  }

  onEdit(toolbox_talk_id: number | string) {
    this.utils.showComponentDialog(ToolboxTalksTemplatesEditComponent, {
      id: toolbox_talk_id
    }, {}, () => {
      this.getToolboxTalk(Number(toolbox_talk_id));
    });
  }

  onRemove() {
    this.utils.showModal(
      'Remove ' + this.utils.getLangTerm('toolbox-talks.singular', 'Toolbox Talk'),
      'Are you sure you want to remove this ' + this.utils.getLangTerm('toolbox-talks.singular', 'Toolbox Talk') + '?',
      () => {
        this.oldApi.laravelApiRequest(
          'delete',
          'toolbox-talks/' + this.toolbox_talk.id,
          {},
          {},
          () => {
            this.utils.showToast('The ' + this.utils.getLangTerm('toolbox-talks.singular', 'Toolbox Talk') + ' was removed.');
            this.router.navigate(['toolbox-talks']);
          },
          (error) => {
            this.utils.showModal('Error', error.message);
          }
        );
      }
    );
  }

  getToolboxTalk(toolbox_talk_id: number) {
    this.oldApi.laravelApiRequest(
      'get',
      'toolbox-talks/' + toolbox_talk_id,
      {},
      {},
      (response) => {
        this.toolbox_talk.apply(response.data);

        if (response.data.reported_by_user) {
          this.reported_by_user = response.data.reported_by_user;
        }
      },
      (error) => {
        this.utils.showModal('Error', error.message);
      },
      {
        template: "true"
      }
    );
  }

  onUserPublicView(hash: string, event: Event): void {
    // Stop default browser actions and event propagation.
    event.preventDefault();
    event.stopPropagation();

    this.utils.showComponentDialog(
      UserPublicProfileComponent,
      hash,
      { width: '90%' },
      () => {
        // Refresh the list regardless of how the dialog is closed.
      }
    );
  }
}
